export const END_AFTER = "endAfter";
export const END_BY = "endBy";
export const DEFAULT_OCCURENCES = 10;
export const MAX_YEARS = 8;
export const DAY_END_LIMIT = 28;
export const DAY_START_LIMIT = 0;
export const END_AFTER_LIMIT = 99;
export const END_AFTER_START = 1;
export const START_DATE = "startDate";
export const END_DATE = "endDate";
export const DEFAULT_RECCURENCE_TIME = "01:00";
export const ACTIVE = "Active";
export const INACTIVE = "Inactive";
